'use client';

import { motion } from 'framer-motion';
import { Navbar } from '../components/layout/navbar';
import { Footer } from '../components/layout/footer';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

export default function GetStartedPage() {
    return (
        <div className="flex min-h-screen flex-col bg-black text-white selection:bg-violet-500/30">
            <div className="fixed inset-0 z-0 pointer-events-none">
                <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-violet-900/20 via-black to-black" />
            </div>

            <Navbar />

            <main className="flex-1 relative z-10 pt-24 pb-20 flex items-center">
                <div className="container px-4 md:px-6 text-center">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        className="max-w-2xl mx-auto p-1 py-1 rounded-[2.5rem] bg-gradient-to-r from-violet-500 to-cyan-500"
                    >
                        <div className="bg-black rounded-[2.3rem] p-12 md:p-16">
                            <h1 className="text-4xl md:text-6xl font-bold mb-6">Start your journey</h1>
                            <p className="text-zinc-400 text-lg mb-10">
                                Join Talktrail today. Create your profile, connect your wallet, and start contributing to the Decentralized Knowledge Graph.
                            </p>

                            <div className="flex flex-col gap-4">
                                <Link to="/sign-up">
                                    <Button className="w-full h-14 text-xl rounded-xl bg-white text-black hover:bg-zinc-200 font-bold transition-transform hover:scale-105">
                                        Sign Up
                                    </Button>
                                </Link>
                                <Link to="/sign-in">
                                    <Button variant="outline" className="w-full h-14 text-xl rounded-xl border-white/10 hover:bg-white/5 transition-transform hover:scale-105">
                                        Log In
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </main>

            <Footer />
        </div>
    );
}
